import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=18b637b9&scoped=true"
import script from "./Deposits.vue?vue&type=script&lang=js"
export * from "./Deposits.vue?vue&type=script&lang=js"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=18b637b9&prod&scoped=true&lang=css"
import style1 from "./Deposits.vue?vue&type=style&index=1&id=18b637b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b637b9",
  null
  
)

export default component.exports